import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=fc1ff668&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=ts&"
export * from "./IconButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1ff668",
  null
  
)

export default component.exports